export const columns = () => {
  return [
    {
      accessorKey: "key",
      header: "Key",
    },
    {
      accessorKey: "name",
      header: "Name",
    },
    {
      accessorKey: "type",
      header: "Type",
    },
    {
      accessorKey: "value",
      header: "Value",
    },
    {
      accessorKey: "description",
      header: "Description",
    },
  ];
};
